<template>
  <ul class="group_selector_list">
    <li v-for="(item, index) in rcpList" :key="index" class="group_selector_item">
      {{item.recipientName}} <button @click="$emit('delete', item)" class="btn_del">삭제</button>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['rcpList']
}
</script>
